import { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const useNotificacoes = () => {
  const { user, isAdmin } = useAuth();
  const [vencimentosAtrasados, setVencimentosAtrasados] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !isAdmin) return;

    const fetchAtrasados = async () => {
      setLoading(true);
      try {
        const { data } = await api.get('/vencimentos');
        setVencimentosAtrasados((data || []).filter(v => v.status === 'Atrasado'));
      } catch {
        // silencioso — falha de notificação não deve travar a UI
      } finally {
        setLoading(false);
      }
    };

    fetchAtrasados();
    const interval = setInterval(fetchAtrasados, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [user, isAdmin]);

  return {
    totalAtrasados: vencimentosAtrasados.length,
    vencimentosAtrasados,
    loading,
  };
};

export default useNotificacoes;
